
import { Main, Aside, Alert, Notification, Message } from "apower-ui";
import VueLazyload from "vue-lazyload";
import "@/styles/single.scss";
import comment from "@/components/comments/comment.js";
import ArticleRating from "@/components/reviews/ArticleRating";
import ShareVertical from "@/components/ShareVertical";
          // window.installFramework = window.installFramework || Function.prototype
          installFramework(function(Vue) {
            // 文章模板页


const components = [Main, Aside, Alert, ArticleRating, ShareVertical];
Vue.use(VueLazyload);
Vue.prototype.$notify = Notification;
Vue.prototype.$message = Message;

components.forEach((component) => {
  Vue.component(component.name, component);
});

new Vue({
  extends: comment,
  methods: {},
}).$mount("#app");

          })
        